module.exports = __webpack_public_path__ + "static/media/download_vault.b3e270c7.svg";